import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { DeviceMarketplace } from './-components/DeviceMarketplace';
import { SearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/marketplace/_store/store/devices/',
)({
  component: DeviceMarketplace,
  validateSearch: zodValidator(SearchSchema),
});
